module.exports = __webpack_public_path__ + "img/ico_square.fc1d50c6.svg";